import { useState } from "react";

export default function Section18() {
  const faqs = [
    {
      question: "How long does it take to develop a website?",
      answer:
        "6–16 weeks depending on features and complexity. We provide clear timelines upfront.",
    },
    {
      question: "Do you build Shopify apps?",
      answer:
        "Yes. We develop Shopify apps and custom integrations for businesses in UAE.",
    },
    {
      question: "Are your websites SEO-optimized?",
      answer:
        "Every website follows best SEO practices including speed, mobile-friendliness, and clean code.",
    },
    {
      question: "Do you offer post-launch support?",
      answer:
        "Yes. Ongoing maintenance, updates, and monitoring are included.",
    },
    {
      question: "What industries do you work with in UAE?",
      answer:
        "We serve ecommerce, SaaS, healthcare, real estate, tech startups, retail, and more.",
    },
    {
      question: "How much does website development cost in UAE?",
      answer:
        "Costs depend on features and complexity. We offer transparent pricing for startups and enterprises.",
    },
    {
      question: "Does Mean3 handle platform migrations?",
      answer:
        "Yes. We migrate from Magento, WooCommerce, BigCommerce, or custom CMS to Shopify Plus or modern frameworks.",
    },
    {
      question: "Do you develop bilingual websites for UAE businesses?",
      answer:
        "Yes. Websites in English and Arabic are available to reach your full audience.",
    }
  ];

  const [isOpen, setIsOpen] = useState(new Array(faqs.length).fill(false));

  const handleFaq = (index) => {
    setIsOpen((prevState) =>
      prevState.map((item, idx) => (idx === index ? !item : false))
    );
  };

  return (
    <div className="w-full SectionWebsiteFAQs mt-[8%] md:mt-[-4%]">
      <div className="w-full section-container">
        <div className="w-[90%] md:w-[61%] pb-[1%] mx-auto text-center">
          <h2 className="leading-[29px] md:leading-[41px] text-[24px] md:text-[30px] text-[#151515] font-bold my-[0.67em]">
            Frequently Asked Questions About Website Development in UAE
          </h2>
        </div>

        <div className="w-full md:w-[784px] p-5 md:p-[2%] mx-auto faq-container font-open leading-[21px]">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]"
            // style={{
            //   background:
            //     "linear-gradient(0deg, #FEFFFF, #FEFFFF), linear-gradient(0deg, #DEDEDE, #DEDEDE)",
            // }}
            >
              <div
                onClick={() => handleFaq(index)}
                className="question text-[#444444] cursor-pointer flex justify-between items-center"
              >
                {faq.question}
                <b className="text-[40px] text-[#DA2128] font-[300]">
                  {isOpen[index] ? "-" : "+"}
                </b>
              </div>
              <div className={`${isOpen[index] ? "block" : "hidden"} answer text-[#444444]`}>
                <br />
                <p className="mb-5">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center mt-8">
          <a
            href="https://mean3.com/contact-mean3"  // replace with your desired link if different
            className="bg-[#DA2128] hover:bg-[#b71c22] text-white px-8 py-3 rounded-lg font-semibold text-[15px] md:text-[16px] transition-all duration-300 inline-block text-center"
          >
            Ask Your Question
          </a>

        </div>
      </div>

      {/* Divider Line */}
      <div className="line mb-[55px] md:mb-[4%] mt-[1%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}
